module.exports = __webpack_public_path__ + "static/media/health-1.5cb527db.jpg";